function getDesiredScrollPositionForElements(elements, topAdjustment) {
    var viewportHeight = document.documentElement.clientHeight;
    var viewportTop = window.scrollY;
    var viewportBottom = viewportTop + viewportHeight;
    var firstElement = elements[0];
    var lastElement = elements[elements.length - 1];
    var firstRect = firstElement.getBoundingClientRect();
    var lastRect = lastElement.getBoundingClientRect();
    var firstTop = viewportTop + firstRect.top;
    var topPosition = firstTop + topAdjustment;
    var lastHeight = lastElement.scrollHeight;
    var lastTop = viewportTop + lastRect.top;
    var lastBottom = lastTop + lastHeight;
    var totalHeight = elements.reduce(function (acc, element) { return acc + element.scrollHeight; }, 0);
    if (topPosition - viewportTop < 0) {
        /*
          buttonRect.top will be negative if the user scrolled beyond the header,
          so if the header is above the viewport, we will scroll to the top of the button
          will scroll to the start of the button
        */
        return topPosition;
    }
    if (lastBottom > viewportBottom) {
        // if the botton of the viewport is after the bottom of the button
        if (totalHeight > viewportHeight) {
            // if the height of the button + height of the content don't fit in the viewport
            // will scroll to the start of the button
            return topPosition;
        }
        // scrolls so the end of the page matches the end of the viewport
        return lastBottom - viewportHeight + topAdjustment;
    }
    return null;
}
/**
 * Scrolls the elements into view, following some rules
 *
 * - If the first element is before the viewport, scrolls to the top of the first element
 * - If the last element is after the view port, scrolls the page so the bottom of the last element is aligned to the bottom of the viewport
 * - If all the elements just don't fit the page, scroll to the top first element
 * - If all the elements fit the viewport, don't do anything
 * @param elements the array of elements, as they appear on the page. Do not send non-visible elements
 * @param behavior The argument to pass to the behavior of window.scrollTo
 */
export function scrollElementsIntoView(elements, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.behavior, behavior = _c === void 0 ? 'smooth' : _c, topAdjustment = _b.topAdjustment;
    var top = getDesiredScrollPositionForElements(elements, topAdjustment || 0);
    if (top) {
        window.scrollTo({ top: top, behavior: behavior });
    }
}
//# sourceMappingURL=scrollElementsIntoView.js.map